import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import isEqual from "lodash/isEqual";
import PropTypes from "prop-types";
import { EDIT_PROJECT_TEMPLATE_ELEMENT_SUCCESS } from "~/store/action_types";
import { editProjectTemplateElement } from "~/store/actions/actions.projectTemplateElements";
import { updateSubscribers } from "~/store/actions/actions.subscription";
import { getSubscriberIdsByTypeAndId } from "~/store/selectors/selector.subscription";
import { TemplateDiscussionAndNoteForm } from "./TemplateDiscussionAndNoteForm";

export const TemplateDiscussionAndNoteEditForm = ({ element }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const templateId = element?.template_id;

  const initialSubscriberIds = useSelector((state) => getSubscriberIdsByTypeAndId(state, element.class, element.id));

  const handleCancel = useCallback(() => {
    navigate(location.pathname + location.search, { replace: true, state: null });
  }, [location.pathname, location.search, navigate]);

  const handleSubmit = useCallback(
    async (updates) => {
      const first = [...updates.subscribers].sort();
      const second = [...initialSubscriberIds].sort();
      if (!isEqual(first, second)) {
        dispatch(updateSubscribers(element?.id, element.class, updates.subscribers));
      }
      await dispatch(editProjectTemplateElement(element?.id, templateId, { ...element, ...updates })).then(
        (response) => {
          if (response.type === EDIT_PROJECT_TEMPLATE_ELEMENT_SUCCESS) {
            return handleCancel();
          }
        }
      );
    },
    [dispatch, element, handleCancel, initialSubscriberIds, templateId]
  );

  return (
    <TemplateDiscussionAndNoteForm
      initialState={{
        ...element,
        attachmentIds: element?.attachments,
        subscribers: initialSubscriberIds || [],
        attachments: {
          filesToAttach: [],
          filesToDrop: [],
        },
      }}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
    />
  );
};

TemplateDiscussionAndNoteEditForm.propTypes = {
  element: PropTypes.object.isRequired,
};
